/* cart-page-live-refresh.js
   Refreshes the cart page's line items / price / upsell blocks
   after Rebuy adds a product, without a full page reload.
   Fully self-contained — does not reference or modify any
   other script (shipping bar, sidebar drawer, etc).
*/
(function () {
  'use strict';

  var CPLR_REFRESH_IN_PROGRESS = false;
  var CPLR_LAST_SECTION_HTML = null;

  function cplr_getCartContainer() {
    return document.querySelector('[data-cart-page][data-section-id]');
  }

  function cplr_refreshCartSection() {
    if (CPLR_REFRESH_IN_PROGRESS) return;

    var container = cplr_getCartContainer();
    if (!container) return; // not on cart page, do nothing

    var sectionId = container.getAttribute('data-section-id');
    if (!sectionId) return;

    CPLR_REFRESH_IN_PROGRESS = true;

    fetch(window.location.pathname + '?section_id=' + sectionId, {
      method: 'GET',
      cache: 'no-store',
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart section fetch failed');
        return res.text();
      })
      .then(function (html) {
        // Skip DOM work if nothing actually changed
        if (html === CPLR_LAST_SECTION_HTML) return;
        CPLR_LAST_SECTION_HTML = html;

        var parser = new DOMParser();
        var newDoc = parser.parseFromString(html, 'text/html');
        var newContainer = newDoc.querySelector('[data-cart-page][data-section-id]');
        var currentContainer = cplr_getCartContainer();

        if (newContainer && currentContainer) {
          currentContainer.replaceWith(newContainer);

          // Fire a generic signal only — other scripts opt in if they want it.
          // This does not call or depend on any other script's functions.
          document.dispatchEvent(new CustomEvent('cplr:cart-section-updated'));
        }
      })
      .catch(function (err) {
        console.error('[Cart Page Live Refresh]', err);
      })
      .finally(function () {
        CPLR_REFRESH_IN_PROGRESS = false;
      });
  }

  function cplr_init() {
    // Only listen for Rebuy's own event — no shared event names
    // with the shipping bar script (which listens on rebuy:cart.change
    // too, but that's fine: multiple listeners on the same event
    // don't conflict, each just runs independently).
    document.addEventListener('rebuy:cart.change', function () {
      setTimeout(cplr_refreshCartSection, 300);
      setTimeout(cplr_refreshCartSection, 800);
      setTimeout(cplr_refreshCartSection, 1500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cplr_init);
  } else {
    cplr_init();
  }
})();